import { render } from "./AppMain.vue?vue&type=template&id=2cfe719a&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=2cfe719a&scoped=true&lang=css"
import "./AppMain.vue?vue&type=style&index=1&id=2cfe719a&lang=scss"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfe719a"]])

export default __exports__